import {isNullOrUndefined} from "util";

export interface IUserInfo {
  who: string;
  mail: string;
  locale: string;
}

export type FileActions = 'open' | 'export' | 'rename' | 'delete' | 'create' | 'save' | 'export';

export interface FolderAction {
  action: FileActions;
  path: string;
  description: string;
}

export interface IRenameResource {
  id: string;
  path: string;
  oldName: string;
  newName: string;
  isFile: boolean;
}

export interface IFileAction {
  action: FileActions;
  file: IeDsResource;
}

export interface IeDsFile {
  id: string;
  label: string;
  creationDate: string;
  description: string;
  readonly?: string;
  url?: string;
  isFolder: boolean;
  path: string;                        // Not used
}

export interface IeDsFolder {
  id?: string;
  label: string;
  readonly?: string;
  folder?: IeDsFolder[] | IeDsFolder;
  file?: IeDsFile[] | IeDsFile;
  isFolder: boolean;
  path: string;                        // Not used
}

export type IeDsFileSystem = IeDsFolder;

export type IeDsResource = IeDsFile | IeDsFolder;

export function iseDsFile(row: IeDsResource) {
  return isNullOrUndefined(row.isFolder) || row.isFolder === false;
}

export function isValidResourceName(name: string): boolean {
  // not null and not empty name are allowed as resource name
  return !(isNullOrUndefined(name) || name.trim() === '');
}
